import PubSub from "pubsub-js";
import type { StateCreator } from "zustand";

import { PubSubActions } from "@/global/pubsub-actions.ts";
import { pushTimelineData } from "@/modules/workflow/stores/undo-redo/pushTimelineData.ts";
import { redo } from "@/modules/workflow/stores/undo-redo/redo.ts";
import { undo } from "@/modules/workflow/stores/undo-redo/undo.ts";
import type {
  WorkflowEditorStore,
  WorkflowUndoRedoSlice,
  WorkflowUndoRedoSliceState,
} from "@/modules/workflow/stores/workflow-editor-store-types.ts";

export const initialUndoRedoSliceState: WorkflowUndoRedoSliceState = {
  canUndo: false,
  canRedo: false,
  timeline: [],
  timelineIndex: 0,
};

export const createUndoRedoSlice: StateCreator<WorkflowEditorStore, [], [], WorkflowUndoRedoSlice> = (set, get) => {
  PubSub.subscribe(PubSubActions.LOGOUT, () => {
    set(initialUndoRedoSliceState);
  });

  return {
    ...initialUndoRedoSliceState,
    pushTimelineData: ({ nodes, edges, parameters }) => pushTimelineData(set, get, nodes, edges, parameters),
    undo: () => undo(set, get),
    redo: () => redo(set, get),
  };
};
